import { usePage } from 'frontend/src/contexts/PageProvider'
import SidebarText from './SidebarText'
import SidebarLinks from './SidebarLinks'

const SidebarRender = () => {
  const page = usePage();
  const sidebar = page?.sidebar;

  if(sidebar?.type == 'text') return <SidebarText sidebar={sidebar} />;
  if(sidebar?.type == 'scroll') return <SidebarLinks mode="ANCHOR" sidebar={sidebar} />;
  if(sidebar?.type == 'links') return <SidebarLinks mode="LINKS" sidebar={sidebar} />;

  return <></>;
}


export default SidebarRender